import {
  ON_CHANGE_DEBOUNCE_TIMER,
  debounce,
  fetchConfig,
} from '../storefront/globals';

class CartNote extends HTMLElement {
  constructor() {
    super();

    this.autosave = this.hasAttribute('data-autosave');

    if (this.autosave) {
      this.registerAutosave();
    } else {
      this.registerSaveButton();
    }
  }

  registerAutosave() {
    this.addEventListener(
      'input',
      debounce((event) => {
        this.submitNote(event.target.value);
      }, ON_CHANGE_DEBOUNCE_TIMER),
    );
  }

  registerSaveButton() {
    this.parentNode
      .querySelector('button[data-save]')
      .addEventListener('click', (event) => {
        event.preventDefault();

        const note = this.parentNode.querySelector('cart-note textarea').value;
        this.submitNote(note);
      });

    this.addEventListener('input', (event) => {
      const saveButton = this.parentNode.querySelector('button[data-save]');
      const saveText = saveButton.getAttribute('data-save-note-text');
      const closeText = saveButton.getAttribute('data-close-note-text');

      if (event.target.value) {
        saveButton.textContent = saveText;
      } else {
        saveButton.textContent = closeText;
      }
    });
  }

  submitNote(note) {
    const body = JSON.stringify({ note });
    fetch(`${window.routes.cartUpdateUrl}`, {
      ...fetchConfig(),
      ...{ body },
    });
  }
}

customElements.define('cart-note', CartNote);
